export default {
  id: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  sinisterCode: {
    value: '',
    maxlength: '10',
    required: true,
    state: null
  },
  sinisterVersion: {
    value: '',
    maxlength: '5',
    required: true,
    state: null
  },
  businessTypeID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  insuranceID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  stageID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  regulationTypeID: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  receiptDate: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  responsibleID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  budgetSystemID: {
    value: null,
    options: [],
    clearOption: false,
    required: true,
    state: null
  },
  mechanicalWorkshopID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null
  },
  autoTypeID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  brandID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  autoModelID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null
  },
  year: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  color: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  plate: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  chassis: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  insuredID: {
    value: '',
    maxlength: '60',
    required: false,
    state: null
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/register/register-form.js